import createFetchReducerWithNamedType from "../../policies/reducers/utils";

const defaults = {
  loading: false,
  items: []
};

export const auditLogsReducer = createFetchReducerWithNamedType(
  "logs",
  "AUDIT_LOGS",
  defaults
);

export const auditLogEntitiesReducer = createFetchReducerWithNamedType(
  "logs",
  "AUDIT_LOG_ENTITIES",
  defaults
);
